<div class="shell">
  <header class="topbar">
    <div class="app-logo">
      <img src="logo/vigimare-logo_nega.png" alt="Vigimare" />
    </div>
    <div class="actions">
      <div class="notification-wrap">
        <button
          class="notification-btn"
          type="button"
          title="Notifications"
          aria-label="Notifications"
          (click)="toggleNotifications()"
        >
          <span class="notification-icon">&#128276;</span>
          @if (unreadCount() > 0) {
            <span class="notification-badge">{{ unreadCount() > 99 ? '99+' : unreadCount() }}</span>
          }
        </button>

        @if (notificationsOpen()) {
          <div class="notification-backdrop" (click)="closeNotifications()"></div>
          <div class="notification-panel">
            <div class="notification-header">
              <h2>Notifications</h2>
              <button
                class="mark-all-btn"
                type="button"
                [disabled]="unreadCount() === 0"
                (click)="markAllNotificationsAsRead()"
              >
                Mark all read
              </button>
            </div>

            @if (notificationsLoading()) {
              <div class="notification-state">Loading notifications...</div>
            } @else if (notificationsError()) {
              <div class="notification-state error">{{ notificationsError() }}</div>
            } @else if (!notifications().length) {
              <div class="notification-state">No notifications yet.</div>
            } @else {
              <div class="notification-list">
                @for (notification of notifications(); track notification.id) {
                  <button
                    class="notification-item"
                    [class.unread]="!notification.read"
                    type="button"
                    (click)="markAsRead(notification)"
                  >
                    <span class="notification-dot"></span>
                    <span class="notification-content">
                      <strong>{{ notification.title }}</strong>
                      <span>{{ notification.message }}</span>
                      <time>{{ notification.createdAt | date:'short' }}</time>
                    </span>
                  </button>
                }
              </div>
            }
          </div>
        }
      </div>

      <button
        class="diglt-btn"
        type="button"
        title="Open DigLT platform"
        aria-label="Open DigLT platform"
        (click)="openExternalPlatform()"
      >
        <img
          src="logo/logo_diglt.png"
          alt="DIGLT"
          class="diglt-logo"
          height="43" width="140"/>
      </button>
      <app-profile-menu></app-profile-menu>
    </div>
  </header>

  <div class="main">
    <aside class="sidebar">
      <nav class="menu">
        @for (item of menu; track item.path) {
          <a
            class="item"
            [routerLink]="item.path"
            routerLinkActive="active"
            [hidden]="!canShow(item.roles)"
            [routerLinkActiveOptions]="{ exact: item.path === '/' }"
          >
            {{ item.label }}
          </a>
        }
      </nav>
    </aside>

    <section class="content">
      <router-outlet></router-outlet>
      <app-bottom-bar></app-bottom-bar>
    </section>
  </div>
</div>
